export default "__VITE_ASSET__DhVe9wkt__"